import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'odq-page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.scss'],
    standalone: false
})
export class PageContentComponent {}
